import React, { useEffect, useState } from "react";
import { useListFilters } from "../../helper/useListFilters";
import ResponsiveDrawer from "../../component/sidebar/sidebar.component";
import { FontFamily } from "../../component/theme/fontFamily";
import { fontWeight } from "../../component/theme/fontWeight";
import { fontSize } from "../../component/theme/fontSize";
import {
  Box,
  Button,
  CircularProgress,
  FormGroup,
  Grid,
  IconButton,
  Switch,
  TextField,
  Tooltip,
  Typography,
  createSvgIcon,
  styled,
} from "@mui/material";
import { ThemeColor } from "../../component/theme/color";
import CustomDataTable from "../../component/datatable/DataTable";
import OutlineCustomButton from "../../component/button/outlineButton";
import { useDispatch, useSelector } from "react-redux";
import {
  GetCountryAction,
  GetProgramAction,
  GetUniversityAction,
} from "../../Redux/action/SettingAction";
import { showSnackbar } from "../../Redux/action/SnackbarAction";
import { useNavigate, useParams } from "react-router-dom";
import FilterComponent from "../../component/filterForTable/FilterComponent";
import { basicurl, token } from "../../Redux/ServiceUrl/url";
import axios from "axios";
import { GetDegreeAction } from "../../Redux/action/ApplicationAction";
import ConfirmationModal from "../../component/Modal/ConfirmationModal/ConfirmationModal";
import {
  DeleteDegreeAvailableService,
  DeleteProgAvailableService,
  EditProgAvailableService,
} from "../../Redux/service/SettingService";
import { Edit } from "@mui/icons-material";
import DeleteIcon from "@mui/icons-material/Delete";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { CustomPagination } from "../../component/datatable/CustomPagination";
import { toTitleCase } from "../../helper/helper";

const NoPaddingGridItem = styled(Grid)({
  paddingTop: "0px !important",
});

const selectOptions = [
  { value: 10, label: "Option 1" },
  { value: 20, label: "Option 2" },
  { value: 30, label: "Option 3" },
];
const ProgramlistPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { id } = useParams();

  const [Programlist, setProgramlist] = useState([]);

  const [isToggled, setIsToggled] = useState(false);

  const [table_load, setTable_load] = useState(false);

  const [isFilterOpen, setFilterOpen] = useState(false);

  const [Degreelist, setDegreelist] = useState([]);

  const [Universitylist, setUniversitylist] = useState([]);

  const [DegreeList, setCountrylist] = useState([]);

  const [FilterProglist, setFilterProglist] = useState([]);

  const [confirmationopen, setConfirmationOpen] = useState(false);
  const [deleteconfirmationopen, setDeleteConfirmationOpen] = useState(false);

  const [changeBlockStatusOfOrg, setChangeBlockStatusOfOrg] = useState({});
  const [deleteId, setDeleteId] = useState();

  const [loading, setLoading] = useState(true);


  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalCount: 0,
    limit: 50,
    hasNextPage: false,
    hasPrevPage: false,
  });

  const handlePageChange = (page) => {
    setTable_load(true);
    console.log(page);
    let data = {
      page: page,
      limit: limit,
    };
    reload(data);
    // fetchData(page, pagination.limit);
  };
  const [limit, setLimit] = useState(50);

  const handleLimitChange = (newLimit) => {
    setTable_load(true);
    setLimit(newLimit);

    reload({ page: 1, limit: newLimit });
  };
  useEffect(() => {
    setTimeout(() => {
      setLoading(false); // Hide the loader after 2 seconds
    }, 2000); // Simulate 2 seconds of loading time
  }, []);

  // const UniversitylistState = useSelector(
  //   (state) => state.setting?.university?.data?.universities
  // );

  // const DegreelistState = useSelector(
  //   (state) => state.application?.degree?.data?.degrees
  // );

  // const ProgramlistState = useSelector(
  //   (state) => state.setting?.program?.data?.programs
  // );

  const CountrylistState = useSelector(
    (state) => state.setting?.degree?.data
  );
  useEffect(() => {
    // console.log(UniversitylistState?.pagination)
    if (CountrylistState) {
      // const { data, pagination } = CountrylistState;
      // setRows(data);
      setPagination(CountrylistState?.pagination);
    }
  }, [CountrylistState]);

  const fetchData = async (filters) => {
    let string = filters.map((data) => `${data.field}=${data.value}`);
    try {
      let response = await axios.get(
        basicurl + `/api/program/get-all-programs?${string.join("&")}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // const result = await response.json();
      console.log(response);

      setProgramlist(
        response?.data?.programs?.map(({ _id, ...rest }) => ({
          id: _id,
          ...rest,
        }))
      );
    } catch (error) {
      console.error("Error fetching filtered data:", error);
    }
  };

  /**
   * Reload the rows.
   *
   * Every action on this page reloads through here so that a filter which
   * is on screen stays applied. Applying a filter used `fetchData` while
   * every action afterwards used the plain redux action, so the table went
   * back to showing everything while the panel still said a filter was on.
   *
   * The filters live in component state, so leaving the page and coming
   * back starts clean with the full list.
   */
  const { getFilters, applyFilters } = useListFilters(
    (filters) => fetchData(filters),
    () => dispatch(GetDegreeAction({ page: 1, limit: limit }))
  );

  const reload = (data) => {
    // Read through the ref: some of the callers below are memoised with
    // empty deps, so a captured value would be frozen as "no filters".
    const applied = getFilters();
    if (applied.length > 0) {
      fetchData(applied);
      return;
    }
    dispatch(GetDegreeAction(data));
  };

  const handleApplyFilters = applyFilters;

  const columns = [
    {
      field: "name",
      headerName: "Name",
      flex: 1,
      minWidth: 250,
      renderCell: (params) => {
        return <div>{toTitleCase(params.row.name)}</div>;
      },
    },
    {
      field: "action",
      headerName: "Action",
      width: 120,
      renderCell: (params) => {
        const handleEditActionClick = (event) => {
          event.stopPropagation();
          setDeleteId(params.row.id);
          setDeleteConfirmationOpen(true);
        };
        return (
          <Tooltip title="Delete Degree">
            {" "}
            <IconButton onClick={handleEditActionClick}>
              <DeleteIcon sx={{ fill: ThemeColor.RED }} />
            </IconButton>
          </Tooltip>
        );
      },
    },
  ];

  const fields = [
    {
      label: "Degree",
      value: "degree",
      type: "multi-select",
      option: Degreelist,
    },
    ...(!id
      ? [
          {
            label: "University Name",
            value: "university",
            type: "multi-select",
            option: Universitylist,
          },
        ]
      : []),
    {
      label: "Program",
      value: "program",
    },
    // {
    //   label: "Country",
    //   value: "country",
    //   type: "multi-select",
    //   option: [
    //     {
    //       _id: "United States of America (USA)",
    //       title: "United States of America (USA)",
    //     },
    //     { _id: "Canada", title: "Canada" },
    //     {
    //       _id: "United Arab Emirates (UAE)",
    //       title: "United Arab Emirates (UAE)",
    //     },
    //     { _id: "Singapore", title: "Singapore" },
    //     {
    //       _id: "United Kingdom",
    //       title: "United Kingdom",
    //     },
    //   ],
    // },
    // {
    //   label: "State",
    //   value: "state",
    //   type: "multi-select",
    //   option: [
    //     { _id: "Alabama", title: "Alabama" },
    //     { _id: "Alaska", title: "Alaska" },
    //     { _id: "Arizona", title: "Arizona" },
    //     { _id: "Arkansas", title: "Arkansas" },
    //     { _id: "California", title: "California" },
    //     { _id: "Colorado", title: "Colorado" },
    //     { _id: "Connecticut", title: "Connecticut" },
    //     { _id: "Delaware", title: "Delaware" },
    //     { _id: "Florida", title: "Florida" },
    //     { _id: "Georgia", title: "Georgia" },
    //     { _id: "Hawaii", title: "Hawaii" },
    //     { _id: "Idaho", title: "Idaho" },
    //     { _id: "Illinois", title: "Illinois" },
    //     { _id: "Indiana", title: "Indiana" },
    //     { _id: "Iowa", title: "Iowa" },
    //     { _id: "Kansas", title: "Kansas" },
    //     { _id: "Kentucky", title: "Kentucky" },
    //     { _id: "Louisiana", title: "Louisiana" },
    //     { _id: "Maine", title: "Maine" },
    //     { _id: "Maryland", title: "Maryland" },
    //     { _id: "Massachusetts", title: "Massachusetts" },
    //     { _id: "Michigan", title: "Michigan" },
    //     { _id: "Minnesota", title: "Minnesota" },
    //     { _id: "Mississippi", title: "Mississippi" },
    //     { _id: "Missouri", title: "Missouri" },
    //     { _id: "Montana", title: "Montana" },
    //     { _id: "Nebraska", title: "Nebraska" },
    //     { _id: "Nevada", title: "Nevada" },
    //     { _id: "New Hampshire", title: "New Hampshire" },
    //     { _id: "New Jersey", title: "New Jersey" },
    //     { _id: "New Mexico", title: "New Mexico" },
    //     { _id: "New York", title: "New York" },
    //     {
    //       _id: "North Carolina",
    //       title: "North Carolina",
    //     },
    //     { _id: "North Dakota", title: "North Dakota" },
    //     { _id: "Ohio", title: "Ohio" },
    //     { _id: "Oklahoma", title: "Oklahoma" },
    //     { _id: "Oregon", title: "Oregon" },
    //     { _id: "Pennsylvania", title: "Pennsylvania" },
    //     { _id: "Rhode Island", title: "Rhode Island" },
    //     {
    //       _id: "South Carolina",
    //       title: "South Carolina",
    //     },
    //     { _id: "South Dakota", title: "South Dakota" },
    //     { _id: "Tennessee", title: "Tennessee" },
    //     { _id: "Texas", title: "Texas" },
    //     { _id: "Utah", title: "Utah" },
    //     { _id: "Vermont", title: "Vermont" },
    //     { _id: "Virginia", title: "Virginia" },
    //     { _id: "Washington", title: "Washington" },
    //     { _id: "West Virginia", title: "West Virginia" },
    //     { _id: "Wisconsin", title: "Wisconsin" },
    //     { _id: "Wyoming", title: "Wyoming" },
    //   ],
    // },
    // { label: "City", value: "city", type: "text" },
    {
      label: "Contract Type",
      value: "contractType",
      type: "multi-select",
      option: [
        { _id: "Direct", title: "Direct" },
        { _id: "Kaplan", title: "Kaplan" },
        { _id: "EAG", title: "EAG" },
        { _id: "EduCo.", title: "EduCo." },
        { _id: "Shorelight", title: "Shorelight" },
      ],
    },
  ];

  //(ProgramlistState, "catalog data");

  useEffect(() => {
    dispatch({ type: "GetDegreeList", payload: null });
    setTable_load(true);
    let data = {
      page: 1,
      limit: 50,
    };
    reload(data);
  }, []);

  useEffect(() => {
    const updatedData = CountrylistState?.degrees?.map(({ _id, ...rest }) => ({
      id: _id,
      ...rest,
    }));
    setCountrylist(updatedData);
    setTable_load(false);
  }, [CountrylistState]);

  return (
    <div>
      {loading ? (
       <div
       style={{
         display: "flex",
         justifyContent: "center",
         alignItems: "center",
         height: "100vh",
         fontSize: "24px",
         color: "#007bff",
       }}
     >
       <div
         style={{
           position: "relative",
           width: "100px",
           height: "100px",
           borderRadius: "50%",
           overflow: "hidden",
           backgroundColor: "transparent",
         }}
       >
         <div style={{ width: "100%", height: "100%",justifyContent:"center",display:"flex",alignItems:"center" }}>
           <img
             src="/assest/Group.png" // Your image URL
             alt="Loading..."
             style={{ width: "75%", height: "75%", objectFit: "contain" }}
           />
         </div>

         <CircularProgress
           size={100}
           sx={{
             color: ThemeColor.NAVYBLUE, // Customize the loader color
             position: "absolute",
             top: 0,
             left: 0,
             zIndex: 1,
           }}
         />
       </div>
     </div>
      ) : (
        <>
          <Grid container spacing={2} alignItems="center">
            <Grid item lg={12} xs={12}>
              <div className="d-flex align-items-center">
                <IconButton onClick={() => navigate(-1)}>
                  <ArrowBackIcon />
                </IconButton>
                <Typography
                  fontFamily={FontFamily.Poppins}
                  fontWeight={fontWeight.W600}
                  fontSize={fontSize.h2.small}
                >
                  Degree List
                </Typography>
              </div>
            </Grid>
          </Grid>
          <div className="table-container mt-4" style={{ overflowX: "hidden" }}>
            <CustomDataTable
              row={DegreeList ? DegreeList : []}
              columns={columns}
              loading={table_load}
              minTableWidth="100%"
            />
          </div>
          <CustomPagination
            pagination={pagination}
            onPageChange={handlePageChange}
            limit={limit}
            onLimitChange={handleLimitChange}
          />
          <ConfirmationModal
            msg="Updated"
            btnName="Update"
            handleConfirmationClose={() => {
              setProgramlist((prev) =>
                prev.map((data) =>
                  data.id === changeBlockStatusOfOrg.id
                    ? {
                        ...data,
                        isAvailable: changeBlockStatusOfOrg.isAvailable,
                      }
                    : data
                )
              );
              setConfirmationOpen(false);
            }}
            deletefunction={async () => {
              try {
                // const res = await EditProgAvailableService(
                //   changeBlockStatusOfOrg.isAvailable,
                //   changeBlockStatusOfOrg.id
                // );
                // if (res.status === 200) {
                //   dispatch(GetProgramAction(id));
                //   setIsToggled(!isToggled); // Dispatch the action if success
                //   return res; // Return the result so the child can access it
                // } else {
                //   return Promise.reject("Unexpected response status"); // Handle unexpected status codes
                // }
              } catch (e) {
                dispatch(
                  showSnackbar(
                    e.response?.data?.message || "Error occurred",
                    "error"
                  )
                );
                return e;
              }
            }}
            confirmationopen={confirmationopen}
            message={"Want to change the blocking status?"}
          />

          {/* for delete */}
          <ConfirmationModal
            msg="Delete"
            btnName="Delete"
            handleConfirmationClose={() => {
              // setProgramlist((prev) =>
              //   prev.map((data) =>
              //     data.id === changeBlockStatusOfOrg.id
              //       ? {
              //           ...data,
              //           isAvailable: changeBlockStatusOfOrg.isAvailable,
              //         }
              //       : data
              //   )
              // );
              setDeleteConfirmationOpen(false);
            }}
            deletefunction={async () => {
              try {
                const res = await DeleteDegreeAvailableService(deleteId);

                if (res.status === 200) {
                  reload();
                  // setIsToggled(!isToggled); // Dispatch the action if success
                  return res; // Return the result so the child can access it
                } else {
                  return Promise.reject("Unexpected response status"); // Handle unexpected status codes
                }
              } catch (e) {
                dispatch(
                  showSnackbar(
                    e.response?.data?.message || "Error occurred",
                    "error"
                  )
                );
                return e;
              }
            }}
            confirmationopen={deleteconfirmationopen}
            message={"Want to delete this degree?"}
          />
        </>
      )}
    </div>
  );
};

function Degreelist() {
  return (
    <div>
      <ResponsiveDrawer maincontent={<ProgramlistPage />} />
    </div>
  );
}

export default Degreelist;
